import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import ProfileCard from "./ProfileCard";
import axios from "axios";

const ProfileImg = styled.div`
  position: relative;
  display: inline-block;
  background-color: white;
  min-width: 60px;
  min-height: 60px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    box-shadow: 0px 0px 10px -2px gray;
  }
  &:hover {
    > div {
      display: block;
    }
  }
`;

const Profile = ({ employeeNo }) => {
  const [partInfo, setPartInfo] = useState(null);
  const [showTooltip, setShowTooltip] = useState(true);
  const [tooltipPosition, setTooltipPosition] = useState(null);

  const profileImgRef = useRef(null);

  useEffect(() => {
    if (showTooltip && !partInfo) {
      axios
        .get(`${process.env.REACT_APP_BECCO_API_URL}/api/employee/profile/${employeeNo}`)
        .then((res) => setPartInfo(res.data));
    }
  }, [showTooltip]);

  const handleMouseEnter = () => {
    setShowTooltip(true);
    if (profileImgRef.current) {
      const { left, right, top } = profileImgRef.current.getBoundingClientRect();
      const innerWidth = window.innerWidth;
      const position = { x: "", y: "" };
      position.x = top > 180 ? "top" : "bottom";
      position.y = left < 200 ? "left" : right > innerWidth - 200 ? "right" : "center";
      setTooltipPosition({ ...position });
    }
  };

  return (
    <ProfileImg onMouseEnter={handleMouseEnter} onMouseLeave={() => setShowTooltip(false)} ref={profileImgRef}>
      {showTooltip && partInfo && tooltipPosition && (
        <ProfileCard tooltipPosition={tooltipPosition} userInfo={{ employeeNo, ...partInfo }} />
      )}
      <img
        src={`${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${employeeNo}`}
        alt={`profile of ${employeeNo}`}
      />
    </ProfileImg>
  );
};

export default Profile;
